<template>
	<el-popconfirm @confirm="confirm" style="margin-left: 20px;" icon="el-icon-info" icon-color="red" title="确定删除吗？">
		<el-button type="danger" slot="reference" size="small">删除</el-button>
	</el-popconfirm>
</template>

<script>
	export default {
		methods: {
			confirm() {
				this.$emit('confirm')
			}
		}
	}
</script>

<style>
</style>
